import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import UTTouchableWithoutFeedback from '../../../UTTouchableWithoutFeedback';
import { formCategoryPropTypes } from '../../../../../redux/userFormHandlers';
import { appConfig } from '../../../../../config/customization';
import Images from '../../../../../config/assets';

import styles from './styles';

class FormCategoriesList extends Component {
  state = { activeRows: [] };

  componentDidMount = () => {
    if (this.props.categories.length === 1) this.setState({ activeRows: [0] });
  };

  isActive = rowIndex => this.state.activeRows.indexOf(rowIndex) !== -1;

  handleRowPressed(rowIndex) {
    const idx = this.state.activeRows.indexOf(rowIndex);
    if (idx !== -1) {
      this.setState(prevState => ({ activeRows: prevState.activeRows.filter(row => rowIndex !== row) }));
    } else {
      this.setState(prevState => ({ activeRows: [...prevState.activeRows, rowIndex] }));
    }
  }

  render() {
    return (
      <div style={styles.container}>
        {appConfig.forms.showFormCategoriesListTitle && (
          <UTLabel semibold style={styles.listTitle}>
            {this.props.listTitle}
          </UTLabel>
        )}
        {this.props.categories.map((category, index) => (
          <div key={category.id} style={styles.categoryContainer}>
            <UTTouchableWithoutFeedback
              style={styles.categoryRow}
              onClick={() => this.handleRowPressed(index)}
            >
              <UTLabel style={styles.categoryLabel}>{category.name}</UTLabel>
              <img src={this.isActive(index) ? Images.listArrowUp : Images.listArrowDown} alt="" />
            </UTTouchableWithoutFeedback>
            <div
              style={[
                styles.subcategoriesContainer,
                this.isActive(index) && styles.subcategoriesContainerActive
              ]}
            >
              {category.forms.map(subcategory => (
                <UTTouchableWithoutFeedback
                  key={subcategory.id}
                  style={styles.subcategoryRow}
                  onClick={() => this.props.onCategorySelected(subcategory.id)}
                >
                  <UTLabel>{subcategory.name}</UTLabel>
                </UTTouchableWithoutFeedback>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

FormCategoriesList.propTypes = {
  categories: formCategoryPropTypes,
  onCategorySelected: PropTypes.func.isRequired,
  listTitle: PropTypes.string.isRequired
};

export default WithLoading(props => props.loading)(Radium(FormCategoriesList));
